export default __webpack_public_path__ + "static/The Home_Image 5_carousel 1@2x-661d84aa19c61a162b8074b6f1c87b24.jpg";